export default "__VITE_ASSET__CZ05LMrc__"